import { getWalletBookWallet, getWalletLinks } from '@dynamic-labs/wallet-book';
import Phantom from './wallets/solana/phantom.js';
import Coinbase from './wallets/ethereum/coinbase.js';
import Slope from './wallets/solana/slope.js';
import Solflare from './wallets/solana/solflare.js';
import Glow from './wallets/solana/glow.js';
import Blocto from './wallets/flow/blocto.js';
import Dapper from './wallets/flow/dapper.js';
import { isMobile, isIPad, isIPhone } from './utils/isMobile.js';
import { fetchWalletConnectWallets } from './utils/walletConnect.js';
import MyAlgo from './wallets/algorand/myalgo.js';
import BraveEvm from './wallets/ethereum/injected/BraveEvm.js';
import Opera from './wallets/ethereum/injected/Opera.js';
import BraveSol from './wallets/solana/injected/BraveSol.js';
import UnknownInjectedWallet from './wallets/ethereum/injected/UnknownInjectedWallet.js';
import GameStop from './wallets/ethereum/injected/GameStop.js';
import ExodusEvm from './wallets/ethereum/injected/ExodusEvm.js';
import ExodusSol from './wallets/solana/injected/ExodusSol.js';
import BloctoInjected from './wallets/ethereum/injected/BloctoInjected.js';
import ArgentX from './wallets/starknet/argentx.js';
import Braavos from './wallets/starknet/braavos.js';
import BloctoEvm from './wallets/ethereum/BloctoEvm.js';
import PhantomLedger from './wallets/solana/phantom-ledger.js';
export { walletName as phantomLedgerWalletName } from './wallets/solana/phantom-ledger.js';
import CoinbaseSolana from './wallets/solana/CoinbaseSolana.js';
import Frame from './wallets/ethereum/injected/Frame.js';
import Fortmatic from './wallets/ethereum/fortmatic.js';
import Lilico from './wallets/flow/lilico.js';
import { getWalletConnectConnector } from './wallets/getWalletConnectConnector.js';
import { initializeWalletProviders } from './wallets/initializeWalletProviders.js';
import Dawn from './wallets/ethereum/injected/Dawn.js';
import PhantomEvm from './wallets/ethereum/injected/PhantomEvm.js';
import 'tslib';
import 'ethers';
import './utils/logger.js';
import './wallets/ethereum/MagicConnector/MagicClientNetworkHandler/MagicClientNetworkHandler.js';
import { EmailOTPMagicWalletConnector } from './wallets/ethereum/MagicConnector/EmailOTPMagicWalletConnector/EmailOTPMagicWalletConnector.js';
import { isEmailWalletConnector } from './utils/isEmailWalletConnector/isEmailWalletConnector.js';
import { getKeplerConnector } from './wallets/cosmos/getKeplrConnector.js';
import Zerion from './wallets/ethereum/injected/Zerion.js';
import { getMobileOrInjectedWallet } from './wallets/getMobileOrInjectedWallet.js';
import MetaMask from './wallets/ethereum/meta-mask.js';
import Trust from './wallets/ethereum/injected/Trust.js';

let wallets = [];
// These wallets are either not supported or implement their
// own WalletConnect connector
const filteredWalletConnectWallets = [
    'MetaMask',
    'Gnosis Safe',
    'Trust',
    'lilico',
    'Keplr',
    'Zerion',
];
const defaultWalletUiUtils = {
    enableInternalSign: () => {
        throw Error('enableInternalSign, not implemented');
    },
    sendTransaction: () => {
        throw Error('requestSendTransactionConfirmation not implemented');
    },
    signMessage: () => {
        throw Error('signMessage not implemented');
    },
};
const getSupportedWallets = ({ appLogoUrl, appName, isWalletConnectV2Enabled, networkConfigurations, skipMemo, vendorCredentials, walletConnectProjectId, walletUiUtils, magicLinkApiKey, magicLinkConfig, } = {
    appLogoUrl: '',
    appName: '',
    isWalletConnectV2Enabled: false,
    networkConfigurations: { cosmos: [], evm: [], solana: [], starknet: [] },
    skipMemo: false,
    vendorCredentials: {},
    walletConnectProjectId: '',
}) => {
    if (!skipMemo && wallets.length > 0) {
        return wallets;
    }
    const evmNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.evm) || [];
    const solanaNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.solana) || [];
    const cosmosNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.cosmos) || [];
    const walletConnectWallets = fetchWalletConnectWallets(evmNetworkConfigs, isWalletConnectV2Enabled);
    // temporary hack to filter out metamask, which currently has walletconnect
    // functionality built-in
    const filtered = walletConnectWallets.filter(({ name }) => !filteredWalletConnectWallets.includes(name));
    const allWallets = [
        new Dawn({ evmNetworks: evmNetworkConfigs }),
        new Phantom({ solNetworks: solanaNetworkConfigs }),
        getMobileOrInjectedWallet({
            evmNetworks: evmNetworkConfigs,
            injectedWallet: new MetaMask({ evmNetworks: evmNetworkConfigs }),
            isWalletConnectV2: isWalletConnectV2Enabled,
            walletConnectName: 'MetaMask',
        }),
        getMobileOrInjectedWallet({
            evmNetworks: evmNetworkConfigs,
            injectedWallet: new Trust({ evmNetworks: evmNetworkConfigs }),
            isWalletConnectV2: isWalletConnectV2Enabled,
            walletConnectName: 'Trust',
        }),
        new PhantomEvm({ evmNetworks: evmNetworkConfigs }),
        new PhantomLedger({ solNetworks: solanaNetworkConfigs }),
        new Coinbase({
            appLogoUrl,
            appName,
            evmNetworks: evmNetworkConfigs,
        }),
        new Solflare({ solNetworks: solanaNetworkConfigs }),
        new Glow({ solNetworks: solanaNetworkConfigs }),
        new Slope({ solNetworks: solanaNetworkConfigs }),
        new Dapper({ appLogoUrl, appName }),
        new Blocto({ appLogoUrl, appName }),
        new BloctoEvm({ evmNetworks: evmNetworkConfigs }),
        new BloctoInjected({ evmNetworks: evmNetworkConfigs }),
        getWalletConnectConnector({
            evmNetworks: evmNetworkConfigs,
            isWalletConnectV2Enabled,
        }),
        new BraveSol({ solNetworks: solanaNetworkConfigs }),
        new BraveEvm({ evmNetworks: evmNetworkConfigs }),
        new UnknownInjectedWallet({ evmNetworks: evmNetworkConfigs }),
        new GameStop({ evmNetworks: evmNetworkConfigs }),
        new ExodusEvm({ evmNetworks: evmNetworkConfigs }),
        new ExodusSol({ solNetworks: solanaNetworkConfigs }),
        new Opera({ evmNetworks: evmNetworkConfigs }),
        ...(magicLinkApiKey
            ? [
                new EmailOTPMagicWalletConnector({
                    apiKey: magicLinkApiKey,
                    config: magicLinkConfig,
                    evmNetworks: evmNetworkConfigs,
                    walletUiUtils: walletUiUtils || defaultWalletUiUtils,
                }),
            ]
            : []),
        new MyAlgo(),
        new ArgentX(),
        new Braavos(),
        new CoinbaseSolana({ solNetworks: solanaNetworkConfigs }),
        new Frame({ evmNetworks: evmNetworkConfigs }),
        new Lilico({ appLogoUrl, appName }),
        getMobileOrInjectedWallet({
            evmNetworks: evmNetworkConfigs,
            injectedWallet: new Zerion({ evmNetworks: evmNetworkConfigs }),
            isWalletConnectV2: isWalletConnectV2Enabled,
            walletConnectName: 'Zerion',
        }),
        //TODO: https://linear.app/dynamic-labs/issue/DYN-2127/rename-evmnetworks-to-networks-across-the-application
        getKeplerConnector({ evmNetworks: cosmosNetworkConfigs }),
        ...((vendorCredentials === null || vendorCredentials === void 0 ? void 0 : vendorCredentials.fortmatic)
            ? [
                new Fortmatic({
                    apiKey: vendorCredentials.fortmatic,
                    evmNetworks: evmNetworkConfigs,
                }),
            ]
            : []),
        ...filtered,
    ];
    initializeWalletProviders({
        evmNetworks: evmNetworkConfigs,
        isWalletConnectV2Enabled,
        walletConnectProjectId,
    });
    // Memoize the wallets
    const filteredWallets = filterWalletsForPlatform(allWallets);
    wallets = applyLinksOverrides(filteredWallets);
    return wallets;
};
const applyLinksOverrides = (wallets) => wallets.map((wallet) => {
    const metadata = getWalletBookWallet(wallet.name);
    if (metadata.switchNetworkOnlyFromWallet !== undefined) {
        wallet.switchNetworkOnlyFromWallet = metadata.switchNetworkOnlyFromWallet;
    }
    return wallet;
});
const filterWalletsForPlatform = (wallets) => wallets.filter((wallet) => {
    const metadata = getWalletBookWallet(wallet.name);
    if (wallet.isInstalledOnBrowser()) {
        return true;
    }
    else if (isEmailWalletConnector(wallet)) {
        return true;
    }
    else if (metadata.showOnlyIfInstalled) {
        return false;
    }
    else if (!isMobile()) {
        return true;
    }
    else {
        return handleMobileWalletFilter(wallet.name, metadata);
    }
});
const handleMobileWalletFilter = (walletName, metadata) => {
    if (!metadata.mobile)
        return false;
    /**
     * WalletConnect provides a "universal" and "native" deep link. They recommend using
     * the universal deep link over the native one due to UX differences, and our current
     * implementation uses only universal. This means we need to filter for wallets that
     * have a universal deep link available.
     */
    const hasWalletConnectLink = Boolean(metadata.mobile.universal) || Boolean(metadata.mobile.native);
    const isWalletConnectWallet = metadata.walletConnect !== undefined;
    if (isIPad() || isIPhone()) {
        const hasIOSLink = Boolean(getWalletLinks(walletName).ios);
        return !isWalletConnectWallet
            ? hasIOSLink
            : hasIOSLink && hasWalletConnectLink;
    }
    else {
        const hasAndroidLink = Boolean(getWalletLinks(walletName).android);
        return !isWalletConnectWallet
            ? hasAndroidLink
            : hasAndroidLink && hasWalletConnectLink;
    }
};
const chainStringToChains = {
    'eip155:1': ['ETH', 'EVM'],
    'flow:mainnet': ['FLOW'],
};
const getSupportedChainsForWalletConnector = (walletConnector) => {
    var _a;
    const metadata = getWalletBookWallet(walletConnector.name);
    /**
     * chains could contain multiple eth networks eg
     *  "eip155:1",
     *  "eip155:10",
     *  "eip155:56",
     *  "eip155:100",
     *
     * so we will use a set to ensure uniqueness
     */
    const chainSet = new Set();
    const chainStringList = (_a = metadata.chains) !== null && _a !== void 0 ? _a : [];
    chainStringList.forEach((chainString) => {
        const chains = chainStringToChains[chainString];
        chains === null || chains === void 0 ? void 0 : chains.forEach((chain) => {
            chainSet.add(chain);
        });
    });
    walletConnector.supportedChains.forEach((chain) => {
        chainSet.add(chain);
    });
    return [...chainSet];
};
const getEnabledWallets = (props) => {
    const supportedWallets = getSupportedWallets(props.getSupportedWalletOpts);
    const isKeplrWalletEnabled = (wallet) => wallet.name.includes('Keplr') &&
        props.enabledNetworks.includes(wallet.networkId) &&
        wallet.isInstalledOnBrowser() === props.installed;
    const allEnabledWallets = supportedWallets.filter((wallet) => isKeplrWalletEnabled(wallet) ||
        (props.enabledChains.some((chain) => getSupportedChainsForWalletConnector(wallet).includes(chain)) &&
            wallet.isInstalledOnBrowser() === props.installed) ||
        wallet.key === 'magiclink');
    return allEnabledWallets;
};

export { filteredWalletConnectWallets, getEnabledWallets, getSupportedChainsForWalletConnector, getSupportedWallets };
